export default __webpack_public_path__ + "static/media/help-circle.3c060dca.svg";